import { render } from "./Teachings.vue?vue&type=template&id=6f0a4582"
import script from "./Teachings.vue?vue&type=script&lang=js"
export * from "./Teachings.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__